



























import {Component, Prop, Vue} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class LoadingDummy extends Vue {
  @Prop() store: any
  @Prop() itemHeight: number
  @Prop() scrollY: number
  @Prop() maxElementRender: number


}

